import React from 'react';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import Icon from 'components/AppIcon';
import { Link } from 'react-router-dom';

const StrategicConsultingServicesPage = () => {
  const consultingServices = [
    {
      icon: 'Target',
      title: 'Stratégie d\'Entreprise',
      description: 'Élaborez une vision stratégique claire et des plans d\'action concrets pour accélérer votre croissance et votre compétitivité.',
      features: ['Diagnostic stratégique', 'Business plan', 'Feuille de route']
    },
    {
      icon: 'TrendingUp',
      title: 'Transformation Organisationnelle',
      description: 'Optimisez vos processus et restructurez votre organisation pour une efficacité opérationnelle maximale.',
      features: ['Optimisation processus', 'Restructuration', 'Gestion du changement']
    },
    {
      icon: 'Briefcase',
      title: 'Développement Commercial',
      description: 'Définissez et déployez des stratégies commerciales performantes pour conquérir de nouveaux marchés.',
      features: ['Stratégie commerciale', 'Expansion marché', 'Performance vente']
    },
    {
      icon: 'Shield',
      title: 'Gouvernance & Conformité',
      description: 'Renforcez votre gouvernance d\'entreprise et assurez la conformité réglementaire pour une gestion optimale.',
      features: ['Cadre de gouvernance', 'Conformité réglementaire', 'Gestion des risques']
    }
  ];

  const keyBenefits = [
    {
      icon: 'Lightbulb',
      title: 'Vision Stratégique',
      description: 'Bénéficiez d\'une analyse approfondie et d\'une vision macro pour des décisions éclairées.'
    },
    {
      icon: 'Users',
      title: 'Experts Reconnus',
      description: 'Collaborez avec des consultants expérimentés ayant fait leurs preuves sur le terrain.'
    },
    {
      icon: 'Zap',
      title: 'Solutions Sur-Mesure',
      description: 'Obtenez des recommandations personnalisées adaptées à votre contexte spécifique.'
    },
    {
      icon: 'Award',
      title: 'Résultats Mesurables',
      description: 'Suivez l\'impact de nos interventions avec des indicateurs de performance concrets.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Section 1: Hero/Introduction */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Compass" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Excellence en Conseil Stratégique
                </span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Conseils Stratégiques
              </h1>
              
              <p className="text-xl md:text-2xl font-semibold" style={{ color: '#9B8E57' }}>
                Accélérez votre croissance avec une vision stratégique
              </p>
              
              <p className="text-lg text-gray-300 leading-relaxed">
                Faites face aux complexités du marché avec l'expertise du Cabinet CRF Perfection. 
                Notre service de Conseil Stratégique vous fournit les analyses, diagnostics et 
                feuilles de route nécessaires pour prendre des décisions éclairées et transformer 
                votre organisation.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link 
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#96121D',
                    boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7d0f18';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#96121D';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Diagnostic Gratuit
                  <Icon name="ArrowRight" size={20} className="ml-2" />
                </Link>
                
                <Link 
                  to="/service-request-form"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 transition-all duration-300"
                  style={{ 
                    borderColor: '#9B8E57',
                    color: '#9B8E57'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#9B8E57';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9B8E57';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Nos Services
                  <Icon name="Briefcase" size={20} className="ml-2" />
                </Link>
              </div>
            </div>

            {/* Right Content - Stats Cards */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Building" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">200+</div>
                <div className="text-gray-300 text-sm">Entreprises Accompagnées</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="TrendingUp" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">+150%</div>
                <div className="text-gray-300 text-sm">ROI Moyen</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="CheckCircle" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">100+</div>
                <div className="text-gray-300 text-sm">Projets Réussis</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Award" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">98%</div>
                <div className="text-gray-300 text-sm">Satisfaction Client</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Consulting Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nos Domaines d'Intervention
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des solutions stratégiques complètes pour transformer votre organisation
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {consultingServices?.map((service, index) => (
              <div 
                key={index}
                className="group bg-gray-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl border-2 border-transparent"
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = index % 2 === 0 ? '#96121D' : '#9B8E57';
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="flex items-start space-x-4 mb-6">
                  <div 
                    className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                    style={{ 
                      backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                    }}
                  >
                    <Icon 
                      name={service?.icon} 
                      size={32} 
                      style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                    />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {service?.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {service?.description}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  {service?.features?.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <Icon 
                        name="CheckCircle" 
                        size={20} 
                        style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                      />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: Key Benefits */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Pourquoi Choisir Notre Conseil Stratégique ?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Une approche éprouvée pour des résultats concrets et durables
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {keyBenefits?.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 text-center transition-all duration-300 hover:shadow-xl"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div 
                  className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{ 
                    backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                  }}
                >
                  <Icon 
                    name={benefit?.icon} 
                    size={36} 
                    style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            ))}
          </div>

          {/* Approach Section */}
          <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Notre Approche
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Une collaboration étroite avec vos équipes, alliant une vision macro des tendances 
                  du marché et une expertise micro pour des solutions concrètes et durables. Nous 
                  transformons les défis en opportunités stratégiques.
                </p>
                <div className="flex items-start space-x-3 mb-4">
                  <Icon name="CheckCircle" size={24} style={{ color: '#96121D' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Diagnostic Approfondi</h4>
                    <p className="text-gray-600">Analyse complète de votre situation et identification des leviers de croissance</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Icon name="CheckCircle" size={24} style={{ color: '#9B8E57' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Accompagnement Opérationnel</h4>
                    <p className="text-gray-600">Support dans la mise en œuvre pour garantir l'atteinte de vos objectifs</p>
                  </div>
                </div>
              </div>

              <div 
                className="rounded-2xl p-8 text-white"
                style={{ 
                  background: 'linear-gradient(135deg, #96121D 0%, #7d0f18 100%)'
                }}
              >
                <h3 className="text-2xl font-bold mb-4">Ce Que Nous Offrons</h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <Icon name="Target" size={24} className="flex-shrink-0 mt-1" />
                    <p>Structuration d'entreprise et optimisation des processus</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="TrendingUp" size={24} className="flex-shrink-0 mt-1" />
                    <p>Élaboration de stratégies de développement sur-mesure</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Users" size={24} className="flex-shrink-0 mt-1" />
                    <p>Gestion du changement et accompagnement humain</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Shield" size={24} className="flex-shrink-0 mt-1" />
                    <p>Renforcement de la gouvernance et conformité</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Transformez Votre Vision en Réalité
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Démarrez votre transformation stratégique dès aujourd'hui avec nos experts
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Search" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Diagnostic Gratuit</h3>
              <p className="text-gray-300 mb-4">Évaluez votre situation stratégique</p>
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Demander un diagnostic <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="FileText" size={32} className="mx-auto mb-4" style={{ color: '#96121D' }} />
              <h3 className="text-xl font-bold mb-2">Étude de Cas</h3>
              <p className="text-gray-300 mb-4">Découvrez nos success stories</p>
              <Link 
                to="/service-request-form"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#96121D' }}
              >
                Voir les études de cas <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Mail" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Proposition Sur-Mesure</h3>
              <p className="text-gray-300 mb-4">Recevez une offre personnalisée</p>
              <Link 
                to="/information-request-form"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Demander une proposition <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>
          </div>

          <div className="text-center">
            <Link 
              to="/contact"
              className="inline-flex items-center justify-center px-12 py-5 text-xl font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl"
              style={{ 
                backgroundColor: '#96121D',
                boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#7d0f18';
                e.target.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#96121D';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Démarrer Mon Projet Stratégique
              <Icon name="ArrowRight" size={24} className="ml-3" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default StrategicConsultingServicesPage;